import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPeopleSvg } from "./IconPeopleSvg.mjs";
const IconPeople = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPeopleSvg, ...svgProps }) });
export {
  IconPeople
};
